import { MAX_TOKEN_REFRESH_HEARTBEAT_DELAY } from '@/constants';
import { getNowMs } from '@/utils/dateUtils';

/**
 * Функция проверяет, жива ли вкладка (могла быть закрыта), обновлящая токен
 *
 * Возвращает true, если превышен интервал (MAX_TOKEN_REFRESH_HEARTBEAT_DELAY) ожидания
 * */
export const isTokenRefreshHeartbeatStopped = (
  lastHeartbeat: number | null,
) => (getNowMs() - (lastHeartbeat || 0)) >= MAX_TOKEN_REFRESH_HEARTBEAT_DELAY;
